import { IDB_fileChunks } from '../IDB/IDB.deviceDB'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import { flatten, map, range } from '../../../shared/lib/functional/array.no-deps'
import { pipe } from '../../../shared/lib/functional/pipe.no-deps'
import { getTotalChunks } from '../../../app-core/lib/upload/chunk'
import type { Upload } from '../../../app-core/lib/upload/Upload'

const chunkId = (fileId: FileId, chunkIndex: number) => `${fileId}-${chunkIndex}`

export const readChunk = async (fileId: FileId, chunkIndex: number) => {
    const { data } = await IDB_fileChunks().get(chunkId(fileId, chunkIndex))
    return data
}

export const writeChunk = async (fileId: FileId, chunkIndex: number, data: ArrayBuffer) => {
    await IDB_fileChunks().put({ data }, chunkId(fileId, chunkIndex))
}

export async function deleteChunks(uploads: Upload[]) {
    await pipe(
        uploads,
        map((u) => u.fileUploadData),
        map((f) => getChunkIdsForFile(f.fileId, getTotalChunks(f.fileSizeInBytes))),
        flatten,
        (ids) => IDB_fileChunks().bulkDelete(ids)
    )
}

function getChunkIdsForFile(fileId: FileId, chunksCount: number) {
    return range(0, chunksCount - 1).map((chunkIndex) => chunkId(fileId, chunkIndex))
}
